import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import type { Form } from 'factorial-form'

import { observer } from 'mobx-react'

import type CustomField from 'modules/custom_resources/store/models/customFields/Field'
import type Field from 'modules/custom_resources/store/models/customResources/Field'

import canEditField from './canEditField'
import isFormComplete from './isFormComplete'

interface ModalProps {
  readonly?: boolean
  disabled?: boolean
  field?: Field | CustomField | null
  form: Form
  modalButton: string
  canManage: boolean
}

const CustomModalFooter = ({
  modalButton,
  form,
  field,
  canManage,
  disabled = false,
  readonly = false,
}: ModalProps) => {
  const disabledButton = (): boolean => {
    // Supplements options have to be editable despite the field being read-only
    if (field?.attributes.usage_group_slug === 'payroll-supplements') {
      return false
    }

    return readonly || disabled || !canEditField(canManage, field) || !isFormComplete(form)
  }

  return (
    <Button disabled={disabledButton()} submit>
      {modalButton}
    </Button>
  )
}

export default observer(CustomModalFooter)
